// ContactUs.js
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../assets/css/student/contact/ContactUs.css';
import { Container } from "react-bootstrap";

const ContactUs = () => {
  return (
    <section className="contact-main-section">
      {/* Top Banner */}
      <div className="contact-banner">
        <Container>
          <div className="contact-banner-inner">
            <h1 className="contact-banner-heading">
              <span className="orange-highlight">Contact Us</span> 
            </h1>
            <p className="contact-banner-text">
              Whether you're looking to support our mission, join as a volunteer, or simply learn more about Student Support Hub, we're here to connect.
            </p>
          </div>
        </Container>
      </div>
    </section>
  );
};

export default ContactUs;